import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import { Badge } from '../../Internal/Badge/Badge.js';
import { ColorPairTeal } from '../../Internal/Badge/colour-pair.js';

const IconBadge = ({ colorPair = ColorPairTeal, size = 'sm', icon, className, }) => {
    return (jsxRuntimeExports.jsx(Badge, { colorPair: colorPair, size: size, className: className, children: icon }));
};
IconBadge.displayName = 'IconBadge';

export { IconBadge };
//# sourceMappingURL=IconBadge.js.map
